
import { defineComponent, PropType } from 'vue'
import QBtn from 'quasar/src/components/btn/QBtn.js';import QIcon from 'quasar/src/components/icon/QIcon.js';
import KeyboardData from '@/types/KeyboardData';
import { keyboardBtnColor } from '@/assets/colors';
import { ColorBlindDataKey, injectStrict } from '@/utils/Injection';

export default defineComponent({
    props: {
        keyboardData: {
            required: true,
            type: Object as PropType<KeyboardData>,
        },
    },
    emits: [
        'onBackPressed',
        'onLetterPressed',
        'onEnterPressed',
    ],
    components: {
      QBtn,  
      QIcon,
    },
    setup() {
        const firstRowLetters = ['Q','W','E','R','T','Y','U','I','O','P',];
        const secondRowLetters = ['A','S','D','F','G','H','J','K','L',];
        const thirdRowLetters = ['Z','X','C','V','B','N','M',];
        const colorBlindData = injectStrict(ColorBlindDataKey);

        return {
            firstRowLetters,
            secondRowLetters,
            thirdRowLetters,
            colorBlindData,
        }
    },
    computed: {
        btnColor() {
            return keyboardBtnColor;
        }
    }
})
